import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const STATUSES = ['pending', 'paid', 'in-design', 'proofing', 'shipped', 'delivered', 'cancelled'];
export const STATUS_COLORS = {
  pending: 'bg-yellow-100 text-yellow-800',
  paid: 'bg-blue-100 text-blue-800',
  'in-design': 'bg-purple-100 text-purple-800',
  proofing: 'bg-orange-100 text-orange-800',
  shipped: 'bg-indigo-100 text-indigo-800',
  delivered: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export const OrdersTable = ({ orders, busy, onStatusChange, onView }) => (
  <Card className="border-stone-taupe/20">
    <CardContent className="p-0 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-soft-linen text-left">
          <tr>
            <th className="p-3">Order #</th>
            <th className="p-3">Customer</th>
            <th className="p-3">Total</th>
            <th className="p-3">Status</th>
            <th className="p-3">Created</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={`${o.orderNumber}-${o.createdAt || o.sessionId || ''}`} className="border-t border-stone-taupe/10" data-testid={`admin-order-row-${o.orderNumber}`}>
              <td className="p-3 font-mono">{o.orderNumber}</td>
              <td className="p-3">
                <div className="font-medium text-charcoal-ink">{o.customerInfo?.name}</div>
                <div className="text-xs text-stone-taupe">{o.customerInfo?.email}</div>
              </td>
              <td className="p-3">${Number(o.total).toFixed(2)}</td>
              <td className="p-3">
                <Badge className={STATUS_COLORS[o.status] || 'bg-stone-100 text-stone-800'}>{o.status}</Badge>
              </td>
              <td className="p-3 text-xs text-stone-taupe">{o.createdAt ? new Date(o.createdAt).toLocaleString() : '—'}</td>
              <td className="p-3">
                <div className="flex gap-2 items-center">
                  <Select onValueChange={(v) => onStatusChange(o.orderNumber, v)}>
                    <SelectTrigger className="w-36 h-8 text-xs" data-testid={`admin-status-select-${o.orderNumber}`}>
                      <SelectValue placeholder="Update status" />
                    </SelectTrigger>
                    <SelectContent>
                      {STATUSES.map((s) => (
                        <SelectItem key={s} value={s}>{s}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Button size="sm" variant="outline" className="text-xs h-8" onClick={() => onView(o.orderNumber)}>
                    View
                  </Button>
                </div>
              </td>
            </tr>
          ))}
          {orders.length === 0 && !busy && (
            <tr><td className="p-6 text-center text-stone-taupe" colSpan={6}>No orders yet</td></tr>
          )}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
